import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();
  const { t } = useTranslation(['common']);

  const sections = [
    {
      title: '一、引言',
      content: [
        '欢迎使用"金安中国"网站及相关服务。',
        '金安中国高度重视用户个人信息和隐私安全。本隐私政策旨在向您说明：在您访问、注册及使用金安中国相关服务过程中，我们如何收集、使用、存储、保护及处理您的个人信息，以及您依法享有的相关权利。',
        '请您在注册或使用本平台服务前仔细阅读本政策。',
        '对于身份证件信息、金融账户信息及其他可能属于敏感个人信息的内容，我们将按照适用法律法规采取更加严格的保护措施。',
        '如相关个人信息并非提供特定服务所必需，您有权拒绝提供。',
        '对于依法需要取得单独同意的敏感个人信息处理活动，本平台应通过独立勾选、单独确认或其他符合法律要求的方式取得您的单独同意，而不以您同意本隐私政策代替依法应当取得的单独同意。',
      ],
    },
    {
      title: '二、个人信息处理者',
      content: [
        '本平台目前使用以下名称向用户提供服务：',
        '平台名称：金安中国',
        '网站域名：jacmarket.cn',
        '个人信息处理者/实际运营主体：待依法确定并填写',
        '特别提示：依法确定后，本平台应当及时、真实、准确地填写上述信息。本平台不得通过本隐私政策虚构公司主体、注册地址、经营许可、金融牌照、贵金属交易资质、政府备案或者监管机构认可。',
      ],
    },
    {
      title: '三、我们收集哪些个人信息',
      content: [
        '根据您使用的具体功能，本平台可能在合法、正当、必要的范围内处理以下个人信息。',
        '3.1 注册和登录信息：手机号码、用户账号、用户ID、登录密码的加密验证信息、验证码记录、注册时间、登录时间、登录IP、登录设备及必要的安全日志信息。处理目的主要包括：创建和管理账号、验证用户身份、防止账号被盗、识别异常登录、保障平台及交易安全。',
        '3.2 实名认证信息：真实姓名、身份证件类型、身份证号码、身份证正面照片、身份证反面照片、实名认证结果。身份证照片及相关身份信息具有较高敏感性，本平台仅应在具有明确目的、充分必要性并采取严格保护措施的情况下处理相关信息。',
        '3.3 银行卡及结算相关信息：银行卡开户人姓名、银行卡号、开户银行、必要的银行卡验证信息、支付订单号、支付金额、支付时间、支付状态、退款信息、结算信息、交易流水及对账信息。金融账户相关信息属于高度敏感的信息，除实际业务确有必要并具有合法处理依据外，本平台不应自行收集或者保存银行卡密码、网上银行密码、短信支付密码、动态支付口令、用户完整支付密码。',
      ],
    },
    {
      title: '四、黄金预订及交易信息',
      content: [
        '当您使用平台提供的黄金相关服务时，我们可能根据实际业务处理：黄金商品名称、黄金品类、黄金成色、黄金重量、黄金报价、用户确认价格、预订价格、订单生成时间、订单编号、订单状态、订单金额、手续费、实物提取申请、实物交付记录、物流或领取信息、退款记录、结算记录、用户与黄金商家之间必要的订单履约信息、客服及交易争议处理信息。',
        '上述信息主要用于订单处理、商品交付、账务核对、交易查询、安全管理及争议处理。',
        '特别说明：本隐私政策仅用于说明个人信息处理规则，不构成对任何黄金交易、保证金交易、差价结算、延期交易、投资业务或者其他业务模式合法性、合规性或经营资质的确认。',
      ],
    },
    {
      title: '五、设备、网络和安全信息',
      content: [
        '为保障账号、网站和交易安全，在符合法律法规要求的范围内，我们可能处理：IP地址、设备类型、操作系统类型、浏览器类型、登录时间、页面访问记录、操作日志、网络日志、异常登录记录、风险操作记录、必要的设备安全识别信息。',
        '我们处理上述信息主要用于：网站正常运行、网络安全防护、识别异常账号、防止恶意注册、防范欺诈、排查系统故障、处理用户投诉、调查异常交易、保存必要的安全证据。',
      ],
    },
    {
      title: '六、我们如何使用个人信息',
      content: [
        '我们可能在合法、正当、必要范围内将个人信息用于：',
        '1. 用户注册及登录；2. 实名身份验证；3. 账号安全管理；4. 黄金商品预订及订单管理；5. 实物黄金提取及交付；6. 支付、退款和结算；7. 向合作黄金商家提供完成订单所必要的信息；8. 客服及投诉处理；9. 交易争议处理；10. 网络及数据安全管理；11. 防范欺诈、盗号及异常交易；12. 履行适用法律法规要求；13. 配合依法有权机关提出的合法要求；14. 经用户依法授权同意的其他用途。',
        '如果个人信息处理目的、方式或者种类发生变化，我们将根据适用法律法规重新履行告知义务，依法需要重新取得同意或者单独同意的，我们将重新取得相应同意。',
      ],
    },
    {
      title: '七、敏感个人信息特别说明',
      content: [
        '根据实际业务，本平台可能涉及处理：身份证号码、身份证照片、银行卡及金融账户相关信息、交易及财产相关信息。',
        '处理上述信息可能产生身份冒用、金融诈骗、财产损失或者其他个人权益风险。因此，本平台将根据实际业务采取包括但不限于以下保护措施：加密传输、访问权限控制、敏感字段脱敏、身份验证、后台权限隔离、安全日志、异常访问监控、必要的数据加密存储、限制工作人员访问范围。',
        '依法需要取得单独同意的，本平台应在处理相关敏感个人信息前取得您的单独同意。',
      ],
    },
    {
      title: '八、个人信息提供及共享',
      content: [
        '我们不会以出售个人信息作为业务经营方式。为了完成相关服务，根据实际业务需要，我们可能向以下类别的第三方提供必要的个人信息：',
        '（一）黄金商家：提供目的为完成黄金订单确认、实物备货、交付、退款、售后及订单争议处理。可能提供的信息包括姓名、联系方式、订单号、黄金规格、重量、订单状态以及完成订单确有必要的其他信息。',
        '（二）银行或支付服务机构：提供目的为完成支付、银行卡验证、退款、结算及资金安全管理。可能涉及的信息包括姓名、支付订单信息、交易金额及相关机构完成支付服务所必要的信息。',
        '（三）实名认证服务机构：提供目的为完成用户身份真实性核验。可能涉及的信息包括姓名、身份证号码、身份证件信息以及完成身份核验所必要的信息。',
        '（四）服务器、云服务及网络安全服务提供商：提供目的为网站运行、数据存储、安全防护、故障排查及网络服务。服务器目前部署地点：香港特别行政区。',
        '（五）短信服务商：提供目的为发送注册验证码、登录验证码、安全提醒或者必要的交易通知。',
      ],
    },
    {
      title: '九、个人信息存储地点',
      content: [
        '根据目前网站技术架构，相关网站服务器部署于：香港特别行政区。',
        '实际个人信息最终存储位置应根据服务器、数据库、实名认证机构、支付机构及其他服务提供商的实际数据处理方式确定。如涉及中国境内自然人个人信息跨境提供或者其他依法需要履行数据出境程序的情况，本平台应按照届时适用的法律法规履行相应义务。',
      ],
    },
    {
      title: '十、个人信息保存期限',
      content: [
        '除法律法规另有规定外，我们原则上仅在实现个人信息处理目的所必要的最短期限内保存个人信息。具体保存期限根据以下因素确定：用户账号存续期限、完成订单所需时间、售后及争议处理期限、保障交易安全所需期限、法律法规要求的保存期限、司法、行政机关依法提出的保存要求。',
        '达到保存期限后，我们将依法采取删除或者匿名化等处理措施。如果因法律法规规定或者技术原因暂时无法删除，我们将依法停止除存储和采取必要安全保护措施之外的其他处理。',
      ],
    },
    {
      title: '十一、Cookie及类似技术',
      content: [
        '为了保障网站正常运行、保持登录状态、识别异常访问及提高网站安全性，本网站可能使用Cookie或者类似技术。必要Cookie可能用于：用户登录、身份验证、安全验证、保存必要的网站设置、防止恶意请求。对于非必要Cookie或者其他需要取得用户同意的技术，我们将按照适用法律法规处理。',
      ],
    },
    {
      title: '十二、您的个人信息权利',
      content: [
        '在符合法律法规规定的情况下，您有权依法：查询个人信息、查阅个人信息、复制个人信息、更正个人信息、补充个人信息、删除个人信息、限制或者拒绝特定个人信息处理、撤回基于同意进行的个人信息处理授权、注销用户账号、在符合法定条件时请求转移个人信息、要求对个人信息处理规则进行解释说明、投诉个人信息处理行为。',
        '本平台不得通过设置不合理条件阻碍用户依法行使上述权利。',
      ],
    },
    {
      title: '十三、撤回授权',
      content: [
        '对于基于用户同意进行的个人信息处理，用户可以通过"个人中心→隐私设置→授权管理"或者通过客服联系方式申请撤回相关授权。',
        '撤回同意不影响撤回前基于用户同意已经进行的个人信息处理活动的效力。如果相关个人信息属于完成用户主动要求的服务所必需的信息，撤回后可能导致对应功能无法继续提供。',
      ],
    },
    {
      title: '十四、账号注销',
      content: [
        '用户可以通过"个人中心→设置→账号安全→注销账号"申请注销金安中国账号。如网站目前尚未开发在线注销功能，应当提供人工注销渠道。',
        '收到申请后，我们可能对申请人的身份进行必要核验，以防止他人恶意注销用户账号。账号注销后，我们将依法处理相关个人信息。对于法律法规要求继续保存或者处理交易纠纷确有必要的信息，在相应期限内我们可能依法继续保存，并限制用于其他目的。',
      ],
    },
    {
      title: '十五、个人信息安全',
      content: [
        '我们将根据实际业务和信息敏感程度采取合理的技术及管理措施保护个人信息，包括：HTTPS安全传输、密码加密或者不可逆处理、数据库访问权限控制、管理后台权限管理、登录安全验证、操作日志、敏感数据访问记录、数据备份、网络攻击防护、异常行为监控、工作人员权限限制。',
        '任何互联网系统均无法承诺绝对不存在安全风险。如发生或者可能发生个人信息泄露、篡改、丢失等安全事件，我们将依法采取补救措施，并按照适用法律法规履行相关通知及报告义务。',
      ],
    },
    {
      title: '十六、未成年人保护',
      content: [
        '考虑到本平台涉及黄金商品、资金结算以及实名认证等服务，本平台原则上仅面向具备相应民事行为能力并符合相关交易条件的用户提供服务。本平台不以不满十四周岁的未成年人作为主要服务对象。如发现未经监护人依法同意而处理了不满十四周岁未成年人的个人信息，我们将按照法律法规要求处理。',
      ],
    },
    {
      title: '十七、隐私政策更新',
      content: [
        '随着平台功能、运营主体、合作机构、服务器架构或者适用法律法规发生变化，我们可能对本政策进行更新。发生重大变化时，我们将根据实际情况通过网站公告、登录弹窗、站内通知、注册页面提示或其他合理方式向用户进行提示。如果更新内容依法需要重新取得用户同意或者单独同意，我们将依法重新取得。',
      ],
    },
    {
      title: '十八、法律适用',
      content: [
        '本隐私政策中的个人信息处理活动应根据具体用户所在地、实际运营主体所在地、个人信息处理地点及服务提供地区，适用相应的法律法规。本政策任何内容均不应被解释为：本平台已经取得任何尚未实际取得的金融、贵金属交易或者其他经营许可；本平台受到任何未实际存在的政府部门、交易场所或者金融监管机构批准、认可或者背书；用户同意本政策即可免除平台依法应当承担的个人信息保护义务；本政策可以取代本平台依法应当取得的经营许可、备案、批准或者其他合规手续。',
      ],
    },
    {
      title: '十九、生效',
      content: [
        '用户在充分阅读并理解本政策后，可以按照网站提供的方式作出相应选择。涉及依法需要单独同意的敏感个人信息处理活动，本平台将另行取得用户的单独同意。',
        '金安中国 网站：jacmarket.cn',
        '版本：V1.0 更新日期：2026年8月11日',
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-brown-50">
      {/* Header */}
      <div className="bg-brown-950 px-4 py-3 flex items-center sticky top-0 z-10">
        <button
          onClick={() => navigate(-1)}
          className="w-8 h-8 flex items-center justify-center text-gold-400 cursor-pointer"
        >
          <i className="ri-arrow-left-line text-lg"></i>
        </button>
        <h1 className="text-gold-400 text-lg font-bold flex-1 text-center pr-8">
          {t('common:privacyPolicy')}
        </h1>
      </div>

      {/* Content */}
      <div className="px-4 py-6 pb-12 max-w-2xl mx-auto">
        <div className="bg-white rounded-xl p-5 md:p-8">
          <h2 className="text-xl font-bold text-brown-900 mb-1">金安中国隐私政策</h2>
          <p className="text-xs text-brown-500 mb-6">版本号 V1.0 · 更新日期 2026年8月11日</p>

          <div className="space-y-6">
            {sections.map((section) => (
              <div key={section.title}>
                <h3 className="text-sm font-bold text-brown-900 mb-2">{section.title}</h3>
                <div className="space-y-2">
                  {section.content.map((paragraph, idx) => (
                    <p key={idx} className="text-sm text-brown-600 leading-relaxed">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}